import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	visible: false,
	points: [],
	fixedLength: false,
}

const pointEditorSlice = createSlice({
	name: 'point_editor',
	initialState,
	reducers: {
		showPointEditor: (state, action) => {
			state.visible = true
			state.points = action.payload.points
			state.fixedLength = action.payload.fixedLength
		},
		hidePointEditor: state => {
			state.visible = false
		},
		updatePoints: (state, action) => {
			state.points = action.payload
		},
		updateFixedLength: (state, action) => {
			state.fixedLength = action.payload
		},
	},
})

export const { showPointEditor, hidePointEditor, updatePoints, updateFixedLength } = pointEditorSlice.actions

// Export selectors
export * from './selectors'

export default pointEditorSlice.reducer
